/* eslint-disable no-unused-vars */
export enum TradeDirection {
  Buy = "Buy",
  Sell = "Sell",
  Pay = "Pay",
  Receive = "Receive",
  Borrow = "Borrow",
  Lend = "Lend",
  BuyPayer = "Buy Payer",
  SellPayer = "Sell Payer",
  BuyReceiver = "Buy Receiver",
  SellReceiver = "Sell Receiver",
  BuyFuture = "Buy Future",
  SellFuture = "Sell Future",
}
